import type { RouterConfig } from '@nuxt/schema';

const CREDIT_GATEWAY_KEY = 'credit-gateway';

export default <RouterConfig>{
  routes: (_routes) => [
    {
      name: 'dashboard',
      path: '/myaccount/home',
      meta: {
        showLeftNav: true,
        customLeftNavHeader: true,
      },
      // @ts-expect-error: Type definitions are not available
      component: () => import('@/pages/Dashboard'),
    },
    {
      name: 'gift-card-balance',
      path: '/account/giftcardbalance',
      meta: {
        showLeftNav: true,
      },
      // @ts-expect-error: Type definitions are not available
      component: () => import('@/pages/GiftCardBalance'),
    },
    {
      name: 'vgc-verify-email',
      path: '/account/vgcverifyemail',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@/pages/VgcVerifyEmail'),
    },
    {
      name: 'nosessioncookie',
      path: '/account/v2/nosessioncookie',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@/pages/NoSessionCookie'),
    },
    {
      name: 'manage-auto-replenishment',
      path: '/account/manageautoreplenishment',
      meta: {
        showLeftNav: true,
      },
      // @ts-expect-error: Type definitions are not available
      component: () => import('@/pages/ManageAutoReplenishment'),
    },
    {
      name: 'guest',
      path: '/my-credit/gateway/guest',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        noScroll: true,
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'signin',
      path: '/account/signin',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/login-component/app/components/views/SignIn.vue'),
      meta: {},
    },
    {
      name: 'create-account-component',
      path: '/account/createaccount',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/create-account-component/app/components/createAccount/CreateAccount.vue'),
      meta: {},
    },
    {
      name: 'cards',
      path: '/my-credit/gateway/cards/:id',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        noScroll: true,
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'amex-offers',
      path: '/my-credit/amex-offers',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/my-credit/amex-offers/index.vue'), // Or the correct path to your component
      meta: {
        showLeftNav: true,
      },
    },
    {
      name: 'make-payment',
      path: '/my-credit/gateway/make-payment/:id',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'authorize-payment',
      path: '/my-credit/gateway/make-payment/authorize/:id',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'payment-confirmation',
      path: '/my-credit/gateway/make-payment/confirmation',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'credit-down',
      path: '/my-credit/gateway/credit-down',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'error',
      path: '/my-credit/gateway/error',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'celebratory-message',
      path: '/my-credit/gateway/celebratory-message',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'gateway',
      path: '/my-credit/gateway',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
      meta: {
        showLeftNav: true,
        key: CREDIT_GATEWAY_KEY,
      },
    },
    {
      name: 'my-credit',
      path: '/my-credit',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/credit-gateway/app/pages/index.vue'),
    },
    {
      name: 'profile-management',
      path: '/account/profile',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/profile-management/app/components/UserProfile.vue'),
      meta: {
        showLeftNav: true,
      },
    },
    {
      name: 'signin-loyalty',
      path: '/account/signin-loyalty',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/login-component/app/components/views/SignIn.vue'),
      meta: {},
    },
    {
      name: 'signout',
      path: '/account/logout',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/login-component/app/components/SignOut.vue'),
      meta: {},
    },
    {
      name: 'forgot-password',
      path: '/forgot-password',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/login-component/app/components/views/ForgotPassword'),
      meta: {},
    },
    {
      name: 'report-abuse',
      path: '/report-abuse',
      // @ts-expect-error: Type definitions are not available
      component: () => import('@nuxt-common/login-component/app/components/views/ReportAbuse'),
      meta: {},
    },
    {
      name: 'aggregator-sign-in',
      path: '/account/signin/aggregator',
      component: () => import('@nuxt-common/login-component/app/components/AggregatorSignInComponent'),
    },
  ],
};
